module.exports = __webpack_public_path__ + "img/tre-jones.e0d68bd5.jpg";